import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import {labels} from '../../../util/utils';
import UnsavedChangesModal from './UnsavedChangesModal';
import _, {isEqual} from 'lodash';
import {useBlocker} from 'react-router';

export default function CustomNavigationPrompt({
	isAresView,
	showPrompt,
	title,
	message,
	closeTitle,
	confirmButtonTitle,
	afterCancel,
	afterConfirm
}) {
	const blocker = useBlocker(({currentLocation, nextLocation}) => {
		const currentUrl = {
			pathname: currentLocation.pathname,
			search: currentLocation.search
		};

		const nextUrl = {
			pathname: nextLocation?.pathname,
			search: nextLocation?.search
		};

		const urlChanged = !isEqual(currentUrl, nextUrl);

		// If the url did not change, do not show the modal
		return urlChanged && showPrompt;
	});

	return blocker.state === 'blocked' ? (
		<UnsavedChangesModal
			isAresView={isAresView}
			show
			title={title}
			confirmButtonTitle={confirmButtonTitle}
			closeTitle={closeTitle}
			onCancel={() => {
				blocker.reset();
				afterCancel && afterCancel();
			}}
			onConfirm={() => {
				blocker.proceed();
				afterConfirm && afterConfirm();
			}}
			message={message}
		/>
	) : null;
}

CustomNavigationPrompt.propTypes = {
	showPrompt: PropTypes.bool,
	title: PropTypes.string,
	message: PropTypes.string,
	closeTitle: PropTypes.string,
	confirmButtonTitle: PropTypes.string,
	beforeCancel: PropTypes.func,
	beforeConfirm: PropTypes.func
};

CustomNavigationPrompt.defaultProps = {
	title: labels.unsavedChangesTitle,
	message: labels.unsavedPageChangesMessage,
	closeTitle: labels.unsavedChangesStay,
	confirmButtonTitle: labels.unsavedChangesLeave
};
